<ng-container *transloco="let t">
  <ng-container *ngIf="!isMobile">
    <div class="modal-header d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center cursor-pointer" (click)="onClose()">
        <img src="assets/icons/icons-alt/modal-back-button.svg" alt="Bookmark" class="pe-2"/>
        <span class="text-uppercase">
                {{t('app.common.back')}}
        </span>
      </div>
      <button type="button" class="btn-close" aria-label="Close" (click)="onClose()"></button>
    </div>
    <div class="modal-body">
      <div class="px-2 pb-3">
        <div class="pb-3">
          <h3 class="text-uppercase fst-normal">{{
              ((competitorResults?.firstName ?? "")| titlecase) + " " + ((competitorResults?.lastName
                ?? "") | titlecase)
            }}</h3>
          <span>{{t('competitor.table.start.number') + ": "}}</span><span
          class="fw-medium">{{competitorResults.startNumber}}</span>
        </div>
        <div class="table-responsive">
          <table class="table table-bordered">
            <thead>
            <tr>
              <th scope="col">{{t('app.common.gender')}}</th>
              <th scope="col">{{t('race.registration.settings.clubSchoolTeam')}}</th>
              <th scope="col">{{t('app.common.country')}}</th>
              <th scope="col">{{t('app.common.status')}}</th>
              <th scope="col">{{t('competitor.table.day.time')}}</th>
              <th scope="col">{{t('competitor.table.time')}}</th>
              <th scope="col">{{t('competitor.table.tempo')}}</th>
              <th scope="col">{{t('competitor.table.speed')}}</th>
              <th scope="col">{{t('competitor.table.absolute.rank')}}</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>
                <div class="d-flex justify-content-center">
                  @if (competitorResults.sex === 1) {
                    <div class="badge-holder__badge gender-badge-man">
                <span class="text-uppercase">
                        {{t("app.common.gender.short.1")}}
                </span>
                    </div>
                  } @else if (competitorResults.sex === 2) {
                    <div class="badge-holder__badge gender-badge-women">
                <span class="text-uppercase">
                        {{t("app.common.gender.short.2")}}
                </span>
                    </div>
                  } @else {
                    <div class="badge-holder__badge gender-badge-man">
                <span class="text-uppercase">
                        {{"-"}}
                </span>
                    </div>
                  }
                </div>
              </td>
              <td>
                {{competitorResults.club ? competitorResults.club : "-"}}
              </td>
              <td>
                {{competitorResults.country ? competitorResults.country : "-"}}
              </td>
              <td>
                <div class="d-flex justify-content-center">
                  <div class="badge-holder__badge finished">
                  <span class="text-uppercase">
                    {{competitorResults.status ? competitorResults.status : "-"}}
                  </span>
                  </div>
                </div>
              </td>
              <td>
                {{competitorResults?.competitorResultsDetail?.fn_tm| resultDateTime:competitorResults?.competitorResultsDetail?.fn_dc:race?.raceSettings?.measurementPrecisionType}}
              </td>
              <td>
                {{competitorResults.competitorResultsDetail | resultsTotalTime:measurementType:race?.raceSettings?.measurementPrecisionType}}
              </td>
              <td>
                {{competitorResults.competitorResultsDetail | competitorTempo:race}}
              </td>
              <td>
                {{competitorResults.competitorResultsDetail | competitorSpeed:race}}
              </td>
              <td>
                <div class="d-flex flex-row justify-content-center">
                  <div class="badge-holder__badge rank-badge">
                  <span class="text-uppercase">
                          {{competitorResults | rank:category:gender:measurementType}}
                  </span>
                  </div>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="pb-3 pt-4">
          <h3 class="text-uppercase fst-normal">{{
              isRoundRace ? t("competitor.table.laps") : t("app.common.controlPoints")
            }}</h3>
        </div>
        <div class="table-responsive">
          <table class="table table-bordered">
            <thead>
            <tr>
              <th scope="col">{{t('competitor.table.type')}}</th>
              <th scope="col">{{t('competitor.table.day.time')}}</th>
              <th scope="col">{{t('competitor.table.time.overall')}}</th>
              <th scope="col">{{t("competitor.table.pass.time")}}</th>
              @if (!isRoundRace) {
                <th scope="col">{{t('competitor.table.absolute.rank')}}</th>
              }
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>
                <div class="d-flex">
                  <div class="badge-holder__badge in-progress">
                  <span class="text-uppercase">
                    {{t('organiser.event.details.control.point.waypointType.3')}}
                  </span>
                  </div>
                </div>
              </td>
              <td>
                {{
                  competitorResults?.competitorResultsDetail?.st_tm|
                    resultDateTime:competitorResults?.competitorResultsDetail?.st_dc:race?.raceSettings?.measurementPrecisionType
                }}
              </td>
              <td>
                -
              </td>
              <td>
                -
              </td>
              @if (!isRoundRace) {
                <td class="text-center">
                  -
                </td>
              }
            </tr>
              @if (isRoundRace && list.length > 0) {
                <tr *ngFor="let competitorStageDetail of list">
                  <td>
                    {{t('measurements.lap.label', {lap: competitorStageDetail.lp})}}
                  </td>
                  <td>
                    {{competitorStageDetail?.ps_tm | resultDateTime:competitorStageDetail?.ps_dc:race?.raceSettings?.measurementPrecisionType}}
                  </td>
                  <td>
                    {{competitorStageDetail?.nt_tm | resultTime}}
                  </td>
                  <td>
                    {{competitorStageDetail?.lp_tm|resultTime:race?.raceSettings?.measurementPrecisionType}}
                  </td>
                </tr>
              } @else if (!isRoundRace && checkpointsIds.length > 0) {
                <tr *ngFor="let cp_id of checkpointsIds;">
                  <td>
                    {{
                      SGS![cp_id]|waypointNameByWaypointId
                    }}
                  </td>
                  <td>
                    {{SGS![cp_id]?.ps_tm | resultDateTime:SGS![cp_id]?.ps_dc:race?.raceSettings?.measurementPrecisionType}}
                  </td>
                  <td>
                    {{SGS![cp_id]?.tl_tm|resultTime:race?.raceSettings?.measurementPrecisionType}}
                  </td>
                  <td>
                    {{SGS![cp_id]?.nt_tm|resultTime:race?.raceSettings?.measurementPrecisionType}}
                  </td>
                  <td>
                    <div class="d-flex flex-row justify-content-center">
                      <div class="badge-holder__badge rank-badge">
                      <span class="text-uppercase">
                              {{SGS![cp_id] | rank:category:gender:measurementType:true}}
                      </span>
                      </div>
                    </div>
                  </td>
                </tr>
              }
              @if (!isRoundRace) {
                <tr>
                  <td>
                    <div class="d-flex">
                      <div class="badge-holder__badge finished">
                      <span class="text-uppercase">
                      {{t('organiser.event.details.control.point.waypointType.4')}}
                      </span>
                      </div>
                    </div>
                  </td>
                  <td>
                    {{competitorResults?.competitorResultsDetail?.fn_tm| resultDateTime:competitorResults?.competitorResultsDetail?.fn_dc:race?.raceSettings?.measurementPrecisionType}}
                  </td>
                  <td>
                    @if (competitorResults?.competitorResultsDetail?.fn_tm) {
                      {{competitorResults.competitorResultsDetail | resultsTotalTime:measurementType:race?.raceSettings?.measurementPrecisionType}}
                    } @else {
                      {{"-"}}
                    }
                  </td>
                  <td>
                    @if (this.sgsFinishItem && competitorResults.status === CompetitorStatus.FIN) {
                      {{sgsFinishItem?.nt_tm|resultTime:race?.raceSettings?.measurementPrecisionType}}
                    } @else if (competitorResults.status === CompetitorStatus.FIN) {
                      {{competitorResults.competitorResultsDetail | resultsTotalTime:measurementType:race?.raceSettings?.measurementPrecisionType}}
                    } @else {
                      -
                    }
                  </td>
                  <td>
                    @if (competitorResults?.competitorResultsDetail?.fn_tm) {
                      <div class="d-flex flex-row justify-content-center">
                        <div class="badge-holder__badge rank-badge">
                      <span class="text-uppercase">
                              {{competitorResults | rank:category:gender:measurementType}}
                      </span>
                        </div>
                      </div>
                    } @else {
                      {{"-"}}
                    }
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="isMobile">
    <div class="modal-header d-flex align-items-center justify-content-end">
      <button type="button" class="btn-close" aria-label="Close" (click)="onClose()"></button>
    </div>
    <div class="modal-body fs-14">
      <div class="card-custom">
        <div class="d-flex flex-column card-custom__top">
          <div class="d-flex justify-content-between align-items-start">
            <div>
              <div class="text-uppercase">
                {{event?.organiser?.name}}
              </div>
              <div class="fw-medium">
                <span class="text-uppercase">
                  <app-language-output [hrLabel]="race?.name" [enLabel]="race?.nameEng" [itLabel]="race?.nameIta"
                                       [siLabel]="race?.nameSlo" [srLabel]="race?.nameSr" [bsLabel]="race?.nameBs"
                                       [languages]="languages"/>
                </span>
              </div>
            </div>
<!--            TODO uncomment after adding navigation to detailsPage-->
<!--            <span class="cursor-pointer">-->
<!--              <img src="assets/icons/icons-alt/share-mobile.svg" alt="Share"/>-->
<!--            </span>-->
          </div>
          <div class="d-flex flex-row justify-content-between align-items-center pt-1">
            <div>{{race?.raceStart | localizedDate:'dd MMM yyyy' | titlecase}}</div>
            <div class="badge-holder__badge" [ngClass]="{
              'started-badge': competitorResults.status === 'STA',
              'finished-badge': competitorResults.status === 'FIN',
              'dnf-badge': competitorResults.status !== 'STA' && competitorResults.status !== 'FIN'
            }">
            <span class="text-uppercase">
              {{competitorResults.status}}
            </span>
            </div>
          </div>
        </div>
        <div class="card-custom__bottom">
          <div class="fw-medium text-uppercase fs-16 d-flex align-items-center">
            <span class="pe-2">
              @if (isTeam) {
              {{ ((competitorResults?.lastName ?? "") | titlecase) }}
              }
              @else {
              {{
              ((competitorResults?.firstName ?? "")| titlecase) + " " + ((competitorResults?.lastName
                      ?? "") | titlecase)
              }}
              }
            </span>

            @if (competitorResults.country) {
              <i [class]="'ioc-' + competitorResults.country"></i>
            }
          </div>
          <div class="d-flex flex-wrap align-items-center">
            <span class="fw-medium me-1">{{t("competitor.table.status.BIB")}}</span>
            <span>
            {{competitorResults.startNumber}}
            </span>
            @if (competitorResults.sex) {
              <div class="item-separator"></div><span> {{
                  t("app.common.gender.short." + competitorResults.sex)|uppercase
                }}</span>
            }
            @if (competitorResults.country) {
              <div class="item-separator"></div><span>{{competitorResults.country}}</span>
            }
            @if (competitorResults.categoryLabel) {
              <div class="item-separator"></div><span>
            {{t("app.common.category.short")}}
                {{competitorResults.categoryLabel |uppercase}}
            </span>
            }

          </div>
          <div>
            {{
              ((competitorResults?.club ?? ""))
            }}
          </div>
        </div>
      </div>

      <div class="d-flex flex-column pt-3">
        <div class="row gx-0">
          <div class="col-4 text-start">
            <div class="text-uppercase">{{ isRoundRace ? t("measurements.controlpoints.lap") : t('competitor.table.time')}}</div>
            <div class="fw-medium">
              {{
              isRoundRace ?
                      (competitorResults.competitorResultsDetail | nmControlPointsOrLaps:true):
                      (competitorResults.competitorResultsDetail |resultsTotalTime:measurementType:race?.raceSettings?.measurementPrecisionType)
              }}
            </div>
          </div>
          <div class="col-4 text-start">
            <div>
              @if (isRoundRace) {
              <span class="text-uppercase pe-1">{{t('competitor.table.time')}}</span>
              }
              @else {
              <span class="text-uppercase pe-1">{{t('competitor.table.tempo')}}</span>
              {{t('competitor.table.tempo.unit')}}
              }
            </div>
            <div class="fw-medium">
              {{isRoundRace ? (competitorResults.competitorResultsDetail |resultsTotalTime:measurementType:race?.raceSettings?.measurementPrecisionType)
                    : (competitorResults.competitorResultsDetail | competitorTempo:race:true)}}
            </div>
          </div>
          <div class="col-4 text-start">
            <div>
              @if (isRoundRace) {
              <span class="text-uppercase pe-1">{{t('competitor.table.tempo')}}</span>
              {{t('competitor.table.tempo.unit')}}
              }
              @else {
              <span class="text-uppercase pe-1">{{t('competitor.table.speed')}}</span>
              {{t('competitor.table.speed.unit')}}
              }
            </div>
            <div class="fw-medium">
              {{isRoundRace ? (competitorResults.competitorResultsDetail | competitorTempo:race:true) : competitorResults.competitorResultsDetail | competitorSpeed:race:true}}
            </div>
          </div>
        </div>

        @if (competitorResults.absoluteRank || competitorResults.sexRank || (competitorResults.category && competitorResults.categoryRank)) {
        <div class="row border-top pt-2 mt-2 gx-0">
          @if (competitorResults.absoluteRank) {
        <div class="col-4 text-start">
          <div class="text-uppercase">{{t("app.common.overall")}}</div>
          <div class="fw-medium">{{competitorResults.absoluteRank}}</div>
        </div>
        }
        @if (competitorResults.sexRank) {
        <div class="col-4 text-start">
          <div class="text-uppercase">{{t("app.common.gender." + competitorResults.sex)|uppercase}}</div>
          <div class="fw-medium">{{competitorResults.sexRank}}</div>
        </div>
        }
        @if (competitorResults.category && competitorResults.categoryRank) {
        <div class="col-4 text-start">
          <div class="text-uppercase">{{competitorResults.categoryLabel}}</div>
          <div class="fw-medium">{{competitorResults.categoryRank}}</div>
        </div>
        }
        </div>
        }


        <div class="row border-top pt-2 mt-2 gx-0">
          @if (race?.raceSettings?.measurementType !== MeasurementTypes.CHIP_TIME_ONLY){
          <div class="col-4 text-start">
            <div class="text-uppercase">
            {{t("competitor.table.gun.time")}}
            </div>
            <div class="fw-medium">
              {{
              competitorResults.competitorResultsDetail |resultsTotalTime:MeasurementTypes.GUN_TIME_ONLY:race?.raceSettings?.measurementPrecisionType:true
              }}
            </div>
          </div>
          }
          @if (race?.raceSettings?.measurementType !== undefined && race?.raceSettings?.measurementType !== null
                && race?.raceSettings?.measurementType !== MeasurementTypes.GUN_TIME_ONLY && race?.raceSettings?.measurementType !== MeasurementTypes.EXTERNAL_IMPORT){
          <div class="col-4 text-start">
            <div class="text-uppercase">
              {{t("competitor.table.chip.time")}}
            </div>
          <div class="fw-medium"> {{
              competitorResults.competitorResultsDetail |resultsTotalTime:MeasurementTypes.CHIP_TIME_ONLY:race?.raceSettings?.measurementPrecisionType:true
              }}
            </div>
          </div>
          }
          @if ((!isAdmin && (race?.raceSettings?.penaltyMinutes === VisibilityTypes.VISIBLE_TO_PUBLIC ||
          race?.raceSettings?.penaltyMinutes === VisibilityTypes.ALWAYS_VISIBLE)) ||
          (isAdmin && race?.raceSettings?.penaltyMinutes !== VisibilityTypes.NOT_VISIBLE)) {
          <div class="col-4 text-start">
            <div class="text-uppercase">{{t("app.common.penaltyMinutes.short")}}</div>
            <div class="fw-medium">{{competitorResults?.competitorResultsDetail?.fn_pen ?? "-"}}</div>
          </div>
          }
        </div>
      </div>

      <div class="card-custom card-custom--noBorder mt-3">
        <div class="d-flex text-uppercase card-custom__top">
          <div class="flex-grow-1 d-flex align-items-center">{{t("competitor.table.end.time")}}</div>
          <div class=" d-flex align-items-center text-left" style="width: 70px;">{{
              t("competitor.table.pass.time")
            }}
          </div>
          <div class=" d-flex align-items-center text-left" style="width: 70px;">
            {{t("competitor.table.time.overall")}}
          </div>
        </div>

        <div class="d-flex align-items-center">
          <div class="d-flex flex-column w-100">
            <div class="d-flex">
              <div class="badge-holder__badge in-progress mt-3">
                <span class="text-uppercase">
                  {{t('organiser.event.details.control.point.waypointType.3')}}
                </span>
              </div>
            </div>

            <ng-container *ngIf="isRoundRace && list.length > 0">
              <ng-container *ngFor="let competitorStageDetail of list">
                <ng-container [ngTemplateOutlet]="pointRow" [ngTemplateOutletContext]="{
                        isLap: true,
                        label: t('measurements.lap.label', { lap: competitorStageDetail.lp }),
                        key: competitorStageDetail.lp!,
                        competitorStageDetail: competitorStageDetail,
                    }"></ng-container>
              </ng-container>
            </ng-container>

            <ng-container *ngIf="!isRoundRace && checkpointsIds.length > 0">
              <ng-container *ngFor="let cp_id of checkpointsIds">
                <ng-container [ngTemplateOutlet]="pointRow" [ngTemplateOutletContext]="{
                        isLap:false,
                        label: SGS![cp_id]|waypointNameByWaypointId,
                        key: cp_id,
                        competitorStageDetail: SGS![cp_id]
                    }"></ng-container>
              </ng-container>
            </ng-container>

            <ng-container *ngIf="!isRoundRace && sgsFinishItem">
              <ng-container [ngTemplateOutlet]="pointRow" [ngTemplateOutletContext]="{
                        isLap:false,
                        isFinish:true,
                        key: 'finish',
                        competitorStageDetail: sgsFinishItem
                    }"></ng-container>
            </ng-container>


            <ng-container *ngIf="!isRoundRace && !sgsFinishItem && competitorResults.status === CompetitorStatus.FIN">
              <ng-container [ngTemplateOutlet]="pointRow" [ngTemplateOutletContext]="{
                        isLap:false,
                        isFinish:true,
                        key: 'finish',
                    }"></ng-container>
            </ng-container>

          </div>
        </div>
      </div>
    </div>
  </ng-container>


  <ng-template #pointRow let-isLap="isLap" let-isFinish="isFinish" let-competitorStageDetail="competitorStageDetail"
               let-label="label" let-key="key">

    <div class="d-flex flex-row py-2 cursor-pointer" (click)="expanded[key] = !expanded[key]" style="padding-right: 8px">
      <div class="flex-grow-1 d-flex align-items-center">
        <img src="assets/icons/icons-alt/chevron-circle-down.svg" class="me-2 chevron-icon"
             [class.rotated]="expanded[key]" alt="toggle"/>
        <ng-container *ngIf="isFinish">
          <div class="badge-holder__badge finished-alt">
                <span class="text-uppercase">
                {{t('organiser.event.details.control.point.waypointType.4')}}
              </span>
          </div>
        </ng-container>
        <ng-container *ngIf="!isFinish">
          {{label}}
        </ng-container>
      </div>

      <ng-container *ngIf="isFinish">
        <div class="data-item">
          {{sgsFinishItem ?
                (sgsFinishItem?.nt_tm|resultTime:race?.raceSettings?.measurementPrecisionType):
                        (competitorResults.competitorResultsDetail | resultsTotalTime:measurementType:race?.raceSettings?.measurementPrecisionType )
          }}
        </div>
        <div class="data-item">
          @if (competitorResults?.competitorResultsDetail?.fn_tm) {
            {{competitorResults.competitorResultsDetail | resultsTotalTime:measurementType:race?.raceSettings?.measurementPrecisionType}}
          } @else {
            {{"-"}}
          }
        </div>
      </ng-container>

      <ng-container *ngIf="!isFinish">
        <ng-container *ngIf="isLap">
          <div class="data-item">
            {{competitorStageDetail?.lp_tm|resultTime:race?.raceSettings?.measurementPrecisionType}}
          </div>
          <div class="data-item">
            {{competitorStageDetail?.nt_tm | resultTime}}
          </div>
        </ng-container>

        <ng-container *ngIf="!isLap">
          <div class="data-item">
            {{competitorStageDetail?.nt_tm |resultTime:race?.raceSettings?.measurementPrecisionType}}
          </div>
          <div class="data-item">
            {{competitorStageDetail?.tl_tm|resultTime:race?.raceSettings?.measurementPrecisionType}}
          </div>
        </ng-container>
      </ng-container>
    </div>

    <div *ngIf="expanded[key]" class="d-flex flex-column card-hidden">
        <ng-container *ngIf="(competitorStageDetail && competitorStageDetail.abrk) || (isFinish && !competitorStageDetail && competitorResults.absoluteRank)">
          <ng-container [ngTemplateOutlet]="dataRow" [ngTemplateOutletContext]="{
                        label: t('app.common.overall'), left: '', right: (competitorStageDetail?.abrk ?? competitorResults.absoluteRank)
                    }"></ng-container>
        </ng-container>

        <ng-container *ngIf="competitorResults.sex && ((competitorStageDetail && competitorStageDetail?.sxrk) || (isFinish && !competitorStageDetail && competitorResults.sexRank)) ">
          <ng-container [ngTemplateOutlet]="dataRow" [ngTemplateOutletContext]="{
                        label: t('app.common.gender.' + competitorResults.sex), left: '', right: (competitorStageDetail?.sxrk ?? competitorResults.sexRank)
                    }"></ng-container>
        </ng-container>

        <ng-container *ngIf="competitorResults.category && competitorResults.categoryLabel && ((competitorStageDetail && competitorStageDetail?.ctrk) || (isFinish && !competitorStageDetail && competitorResults.categoryRank))">
          <ng-container [ngTemplateOutlet]="dataRow" [ngTemplateOutletContext]="{
                        label: competitorResults.categoryLabel | uppercase, left: '', right: (competitorStageDetail?.ctrk ?? competitorResults.categoryRank)
                    }"></ng-container>
        </ng-container>
      <ng-container *ngIf="competitorStageDetail" [ngTemplateOutlet]="dataRow" [ngTemplateOutletContext]="{
                        label: t('competitor.table.day.time'),
                        left: competitorStageDetail?.ps_tm | resultDateTime:competitorStageDetail.ps_dc:race?.raceSettings?.measurementPrecisionType:false:true,
                        right: competitorStageDetail?.ps_tm | resultDateTime:competitorStageDetail.ps_dc:race?.raceSettings?.measurementPrecisionType:true:false
                    }"></ng-container>

      <ng-container *ngIf="!competitorStageDetail && isFinish" [ngTemplateOutlet]="dataRow" [ngTemplateOutletContext]="{
                        label: t('competitor.table.day.time'),
                        left: competitorResults?.competitorResultsDetail?.fn_tm| resultDateTime:competitorResults?.competitorResultsDetail?.fn_dc:race?.raceSettings?.measurementPrecisionType:false:true,
                        right: competitorResults?.competitorResultsDetail?.fn_tm| resultDateTime:competitorResults?.competitorResultsDetail?.fn_dc:race?.raceSettings?.measurementPrecisionType:true:false
                    }"></ng-container>
    </div>
  </ng-template>


  <ng-template #dataRow let-label="label" let-left="left" let-right="right">
    <div class="d-flex flex-row py-2">
      <div class="d-flex align-items-center">
        {{label}}
      </div>
      <div class="data-item ps-2" *ngIf="left !== null && left !== undefined && left !== ''">
        {{left}}
      </div>
      <div class="data-item ps-2" *ngIf="right !== null && right !== undefined && right !== ''">
        {{right}}
      </div>
    </div>
  </ng-template>

</ng-container>
